import React, { useState, useEffect } from 'react';
import { ShoppingCart, ArrowRight } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { tx } from '@/translations/translations';
import { cartUtils } from '@/data/translatedData';

const FREE_SHIPPING_THRESHOLD = 5;

const StickyCartMobile = ({ onCartClick }) => {
  const { language } = useLanguage();
  const [count, setCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const update = () => {
      const items = cartUtils.getCart() || [];
      const c = items.reduce((s, i) => s + (i.quantity || 0), 0);
      const t = items.reduce((s, i) => s + (i.price || 0) * (i.quantity || 0), 0);
      setCount(c);
      setTotal(t);
    };
    update();
    window.addEventListener('cartUpdated', update);
    const onScroll = () => {
      // Hide when near the footer so the user can tap footer links (e.g. Admin).
      const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 420;
      setVisible(window.scrollY > 500 && !nearBottom);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('cartUpdated', update);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  if (count === 0 || !visible) return null;

  const freeShippingLeft = Math.max(0, FREE_SHIPPING_THRESHOLD - count);

  return (
    <button
      onClick={onCartClick}
      data-testid="sticky-mobile-cart"
      className="md:hidden fixed bottom-4 left-4 right-[72px] z-40 flex items-center justify-between gap-3 bg-slate-900 text-white rounded-2xl px-4 py-3 shadow-2xl shadow-slate-900/40 animate-[slideUp_300ms_ease-out]"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="relative flex-shrink-0">
          <div className="w-10 h-10 rounded-full bg-cyan-500/20 flex items-center justify-center">
            <ShoppingCart className="w-4 h-4 text-cyan-400" />
          </div>
          <span className="absolute -top-1 -right-1 bg-cyan-500 text-slate-950 text-[10px] font-black rounded-full h-4 w-4 flex items-center justify-center">
            {count}
          </span>
        </div>
        <div className="text-left min-w-0">
          <p className="text-[11px] text-slate-400 uppercase tracking-wider">
            {freeShippingLeft > 0
              ? tx(language, `Faltan ${freeShippingLeft} para envío gratis`, `${freeShippingLeft} more for free shipping`, `חסרים ${freeShippingLeft} למשלוח חינם`)
              : tx(language, '¡Envío gratis!', 'Free shipping!', 'משלוח חינם!')}
          </p>
          <p className="text-sm font-bold truncate">
            ${total.toFixed(0)} <span className="text-xs font-normal text-slate-400">MXN</span>
          </p>
        </div>
      </div>
      <div className="flex items-center gap-1 bg-cyan-500 text-slate-950 font-bold text-xs px-3 py-2 rounded-full">
        {tx(language, 'Ver', 'View', 'צפה')}
        <ArrowRight className="w-3.5 h-3.5" />
      </div>
    </button>
  );
};

export default StickyCartMobile;
